import {
	faHourglassStart,
	faTimer,
	faTriangleExclamation,
} from '@fortawesome/pro-regular-svg-icons'

/**
 * Maps a basket's processing status onto the coarse step the progress bar shows.
 *
 * Several backend statuses share a step: the bar is a six-step summary, not a mirror of the
 * pipeline. A basket prices either through the opportunity analyzer (ANALYZING) or the pricing
 * endpoint (PRICING) depending on a backend feature flag, so both map to the same step —
 * which route a basket took is not something the bar should expose.
 */
export const progressMap: Record<string, number> = {
	QUEUED: 1,
	GATHERING: 1,
	MATCHING: 2,
	IMPORTING: 2,
	DISCOVERING: 3,
	RECOMMENDING: 3,
	BACKFILLING: 4,
	ANALYZING: 5,
	PRICING: 5,
	ENRICHING: 5,
	VALIDATING: 6,
	FLAGGING: 6,
	SELECTING: 6,
	SCORING: 6,
	FINALIZING: 6,
	FINISHED: 6,
}

export function getStatusFromProgress(currentProgress: number | undefined, progressStep: number) {
	if (currentProgress === undefined) return 'waiting'
	if (currentProgress > progressStep) return 'completed'
	if (currentProgress === progressStep) return 'working'
	return 'waiting'
}

export const statusMap = {
	PENDING: {
		color: 'default',
		icon: faTimer,
		text: 'Pending',
	},
	PROCESSING: {
		color: 'primary',
		icon: faHourglassStart,
		text: 'Processing',
	},
	FAILED: {
		color: 'error',
		icon: faTriangleExclamation,
		text: 'Failed',
	},
}
